// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Nav from './Nav';
import API from './API';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          

          <Routes>
            
            <Route path="/" element={<API />} />
          </Routes>
        </header>
      </div>
    </Router>
  );
}

export default App;
